import React, { useState } from 'react'
import { MuiGrid, MuiTypography } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import { makeStyles,withStyles } from '@material-ui/core/styles';
import TableBody from "@material-ui/core/TableBody";
import MuiTableCell from "@material-ui/core/TableCell";

import TableRow from "@material-ui/core/TableRow";
const TableCell = withStyles({
    root: {
        border: "none", 
    }
})(MuiTableCell);

const useStyles = makeStyles(theme => ({
    root: { height: '1vh' },
    rowGrid: { height: '3vh' },
    rowTitleItemStyle: { fontWeight: 600 },
    rowTitleItemStyleBlur: { filter: 'blur(2px)', fontWeight: 600 },
    rowGridItemStyle: { border: '1px solid ' + theme.palette.grey.dark, textAlign: 'right',  background: theme.palette.grey.lighter, height: '3vh', width: '3%', paddingRight: 4 },
    cellGridStyle: { height: '8vh', width: '97%' },
    emptyGridStyle: { border: '1px solid '+theme.palette.grey.dark, width: '100%', height: '3vh' },
    cellTextStyle: { fontSize: '10px'},
    cellTextStyleBlur: { fontSize: '10px', filter: 'blur(2px)' },
}));
export default function MasterScheduleForClass(props) {
    const classes = useStyles();
    let timeTable = props.timeTable;




    function getTableBody() {
        let rowArray = []

        timeTable.map(function (class1, index2) {
            let cellArray = []
            let cell = <TableCell className={classes.rowGridItemStyle} width="100px" colspan={1} style={{ position: 'sticky',left:0, zIndex: 98}}>
                <MuiTypography variant={theme.typographyStyles.BODY2}  className={props.setTitleStyleBasedOnLicense(props.noOfTimeTableToShowIndex ,index2)}>
                    {props.showText((class1.name).toUpperCase(), props.timeTableType, index2)}
                      </MuiTypography>
            </TableCell>
 
            cellArray.push(cell)
            class1.days.map(function (day1, index3) {
                day1.periods.map(function (period, index1) {
                    let lastPeriod=(day1.periods.length-1==index1 && class1.days.length-1!=index3)
                    let cell = <TableCell style={props.getCellStyle(period.typeOfPeriod, day1, 'cell', ((period.subject != undefined) ? period.subject.color : 'white'), (props.noOfTimeTableToShowIndex< index2),lastPeriod)}>
                        
                        <MuiTypography className={props.setCellStyleBasedOnLicense(props.noOfTimeTableToShowIndex ,index2)} style={{ wordBreak: 'break-all' }}>

                            {period.subject.code != undefined ? props.showText((period.subject.code).toUpperCase(), props.timeTableType,index2) : period.typeOfPeriod != 'lunch' && period.typeOfPeriod != 'break' ? '' : ''}
                            </MuiTypography>

                    </TableCell>
     
                    cellArray.push(cell)
                })
            })
            let row = <TableRow>{cellArray}</TableRow>
            rowArray.push(row);
        })
        return rowArray
    }
    return (
        <TableBody>
            {getTableBody()}
        </TableBody>
    )
}
